export default __webpack_public_path__ + "static/linear-logo-de05fe3ae099d823249a78b8b8c65772.svg";